module.exports = __webpack_public_path__ + "ccd7e5d11fd5af80677fcbb5766180a3.mp4";